import { useState, useEffect } from 'react'
import { ShoppingCartIcon } from "@heroicons/react/16/solid";
import { Link } from "react-router"
import axios from 'axios';
import { useCarts, useCartsDispatch } from '../contexts/CartContext';
import { FireIcon, ShoppingBagIcon, CheckBadgeIcon   } from '@heroicons/react/24/outline';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import Pagination from '@mui/material/Pagination';
import CardProduct from './cardProduct';
import PropTypes from 'prop-types'

const apiurl = `${process.env.REACT_APP_API}`
const imgurl = `${process.env.REACT_APP_URL}/image/products`


const ProductList = props => {
    const [promot, setPromote] = useState(null);
    const [products, setProducts] = useState([]);
    const [topproducts, setTopProducts] = useState([]);
    const [recommend, setRecommend] = useState([]);
    const [prodFilter, setProdFilter] = useState(null);
    const [category, setCategory] = useState([])
    const carts = useCarts();
    const dispatch = useCartsDispatch();
    const [pd, setPd] = useState(null);
    const [searchValue, setSearchValue] = useState('');
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(100);
    const [enable , setEnable] = useState(false);

    useEffect(() => {
        const fetchPromote = async () => {
          try {
            const result = await axios.get(`${apiurl}/products.php?mode=getpromote`);
            
            // console.log(result);
            // console.log(result.data);
            // if(result.data.length>0) {
            if(result.data && result.data[0].length>0) {  
              // const data = await response.json();
              // console.log(result.data[0]);
              setPromote(result.data[0]);
              return result.data[0];
            } //else {
             // setPromote(promote);
           // }
          }
          catch(err) {
              console.log(err);
            }
          }
      
          fetchPromote();
        
      },[]); 
    
      const fetchProducts = async (page) => {
        try {
          const result = await axios.get(`${apiurl}/products.php?mode=getactive`, {
            params: {
              itemsPerPage: 100,
              page: page,
            },
          });
          
        //   console.log(result);
          // console.log(result.data);
          // if(result.data.length>0) {
          if(result.data && result.data[0].length>0) {  
            // const data = await response.json();
            // console.log(result.data[0]);
            setProducts(result.data[0]);
            setProdFilter(result.data[0]);
            setTotalPages(result.data.totalPages);
            // setEnable(result.data.enable);
            setEnable(true);

            return result.data[0];
          }
    
        }
        catch(err) {
            console.log(err);
          }
      }
    
      const fetchTopProducts = async () => {
        // setLoading(true);
        // setReportType(period);
        try {
            const result = await axios.get(`${apiurl}/products.php?mode=gettopproduct`);
            
            // console.log(result);
            if(result.data && result.data[0].length>0) {  
              setTopProducts(result.data[0]);
            }
        } catch (error) {
            console.error('Error fetching summary:', error);
        }
        // setLoading(false);
      };
    
      const fetchRecommend = async () => {
        // setLoading(true);
        // setReportType(period);
        try {
            const result = await axios.get(`${apiurl}/products.php?mode=getrecommend`);
            
            // console.log(result);
            if(result.data && result.data[0].length>0) {  
              setRecommend(result.data[0]);
            }
        } catch (error) {
            console.error('Error fetching summary:', error);
        }
        // setLoading(false);
      };
    
    
      useEffect(() => {
    
        fetchProducts(page-1);
        fetchTopProducts();
        fetchRecommend();
    
      },[])
    
      const fetchCategory = async () => {
        try {
          const result = await axios.get(`${apiurl}/products.php?mode=getcategory`);
          
          // console.log(result);
          // console.log(result.data);
          // if(result.data.length>0) {
          if(result.data && result.data[0].length>0) {  
            // const data = await response.json();
            // console.log(result.data[0]);
            setCategory(result.data[0]);
            return result.data[0];
          }
    
        }
        catch(err) {
            console.log(err);
        }
      }
    
      useEffect(() => {
    
      fetchCategory();
    
      },[])
      
      const setCart = async (pd) => {
        // console.log(pd)
    
        const cartitem = carts.filter((cart) => cart.pdid === pd.id);
        if (cartitem && cartitem.length > 0) {
          dispatch({
            type: 'changed',
            // id: pd.id,
            pdid: pd.id,
            name: pd.name,
            // discount: 0,
            price: pd.price,
            quantity: pd.quantity? pd.quantity : 1,
            imageSrc: pd.img,
    
          });
          
        } else {
          dispatch({
            type: 'added',
            id: pd.id,
            pdid: pd.id,
            name: pd.name,
            // discount: 0,
            price: pd.price,
            quantity: pd.quantity? pd.quantity : 1,
            imageSrc: pd.img,
    
          });
        };
      };
    
      const [open, setOpen] = useState(false);
    
      const handleClickOpen = (product) => {
        // console.log(product);
        setPd(product);
        setOpen(true);
    
      };

      const handleProdCategory = (cat) => {
        const prods = cat==="All"? products : products.filter(pd => pd.category === cat)
        if(prods.length>0) {
          setProdFilter(prods);
        }
      }
    
      
      const handleInputChange = (e) => {
        setSearchValue(e.target.value);
        const prods = products.filter(pd => pd.name.includes(e.target.value))
        // console.log(prods);
        if(prods.length>0) {
          setProdFilter(prods);
        }
      }
    
    const handleProdPageChange = (event, value) => {
        // console.log(value);
        setPage(value);
        if(value !== page) fetchProducts(value);
      };
    
  
  return (
    <div className="w-full min-w-96" >
      <div className="p-4">
        <div className="text-gray-300 mx-auto  px-6 py-2 max-w-7xl lg:px-4 bg-cyan-900 rounded-lg">
          <h2 className="text-2xl tracking-tight"><ShoppingBagIcon className="inline-block h-6 w-6 text-sky-300" />  รายการสินค้า</h2> 
          <div className="flex flex-col sm:flex-row text-sm sm:text-md justify-between">
            <div>
              <span> หมวดสินค้า: 
                  <button onClick={() => handleProdCategory('All')} className="hover:text-slate-100 ml-1 bg-cyan-700 hover:bg-cyan-500 rounded-lg px-2"> All </button>
                {category?.map((cat,i) => (
                  <div key={i} className="inline-block">
                    <span className="ml-1"> / </span> 
                    <button onClick={() => handleProdCategory(cat.category)} className="hover:text-slate-100 bg-cyan-700 hover:bg-cyan-500 rounded-lg px-2"> {cat.category} </button> 
                  </div>
                ))}
              </span>
              </div>
            <div>
            <label className="relative block mt-2 sm:mt-0 ">
              <span className="sr-only">Search</span>
              <span className="absolute top-1 left-0 flex items-center pl-1">
                <SearchOutlinedIcon className="h-5 w-5" />
              </span>
              <input className="placeholder:italic placeholder:text-slate-300 text-slate-600 block bg-white w-full border border-slate-300 rounded-md py-1 pl-7 pr-2 shadow-sm focus:outline-none focus:border-sky-500 focus:ring-sky-500 focus:ring-1 sm:text-sm" 
                placeholder="Search product..." 
                type="text" 
                name="search"
                value={searchValue}
                onChange={handleInputChange}
              />
            </label>
            </div>
          </div>
          <div className="flex text-sm justify-end text-white p-2 mt-1">
            {/* <Stack spacing={2}> */}
              <Pagination 
                count={totalPages} 
                page={page} 
                onChange={handleProdPageChange} 
                size="small" 
                color="primary" 
                sx={{
                  "& .MuiPaginationItem-root": {
                    color: "#ffffff",
                    // fontSize: "8px",
                    // backgroundColor: "#e9b312",
                    // width: "8px",
                    // height: "8px",
                    // padding: 0,
                    // borderRadius: "100%"
                  },
                }}  

              />
            {/* </Stack> */}
          </div>

          <div className="overflow-y-auto mt-0 grid gap-x-2 gap-y-4 grid-cols-3 sm:grid-cols-4 md:grid-cols-6 lg:grid-cols-8 xl:gap-x-6 text-gray-600">
            {prodFilter?.map((product) => (
              <div key={product.id} className="group relative rounded-md hover:border-orange-500 hover:border-2 hover:rounded-md bg-gradient-to-t from-slate-100 from-10% to-60%">
                <div className="grid content-between w-full h-full">
                  <img
                    alt={product.name}
                    src={`${imgurl}/${product.img}`}
                    className="w-full rounded-md object-cover group-hover:opacity-75 hover:cursor-pointer"
                    onClick={() => handleClickOpen(product)}
                  />
                  <div className="mt-4 p-1 flex justify-between">
                    <div>
                      <h3 className="text-sm">
                          <span aria-hidden="true" className="" />
                          {product.name}
                      </h3>
                      <p className="mt-1 text-sm inline-block">{product.category}</p>
                      
                    </div>
                    <div>
                      <p className="flex items-center justify-end p-1 text-sm font-medium text-gray-300 bg-cyan-600 rounded-full">{product.price}</p>
                      {enable && <ShoppingCartIcon 
                        className="h-6 w-6 text-teal-500 inline-block hover:text-teal-700 hover:cursor-pointer"
                        onClick={() => setCart(product)}
                      />
                      }
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="flex justify-end text-white p-4 mt-2">
              <Pagination 
                count={totalPages} 
                page={page} 
                onChange={handleProdPageChange} 
                size="small" 
                color="primary" 
                sx={{
                  "& .MuiPaginationItem-root": {
                    color: "#ffffff",
                  },
                }}  

              />
          </div>
        </div>

        <div className="text-gray-300 mx-auto mt-2 px-6 py-2 max-w-7xl lg:px-4 bg-sky-900 rounded-lg">
          <h2 className="text-2xl tracking-tight"><FireIcon className="inline-block h-6 w-6 text-red-500" /> สินค้ายอดนิยม</h2> 
          <div className="overflow-y-auto mt-6 grid gap-x-2 gap-y-4 grid-cols-2 sm:grid-cols-4 md:grid-cols-5  xl:gap-x-6 text-gray-600">
            {topproducts?.map((product) => (
              <div key={product.id} className="group relative rounded-md hover:border-orange-500 hover:border-2 hover:rounded-md bg-gradient-to-t from-slate-100 from-10% to-60%">
                <div className="grid content-between w-full h-full">
                  <img
                    alt={product.name}
                    src={`${imgurl}/${product.img}`}
                    className="w-full rounded-md object-cover group-hover:opacity-75 hover:cursor-pointer"
                    onClick={() => handleClickOpen(product)}
                  />
                  <div className="mt-4 p-1 flex justify-between">
                    <div>
                      <h3 className="text-sm">
                          <span aria-hidden="true" className="" />
                          {product.name}
                      </h3>
                      <p className="mt-1 text-sm inline-block">{product.category}</p>
                      
                    </div>
                    <div>
                      <p className="flex items-center justify-end p-1 text-sm font-medium text-gray-300 bg-sky-800 rounded-full">{product.price}</p>
                      {enable==='true' && <ShoppingCartIcon 
                        className="h-6 w-6 text-teal-500 inline-block hover:text-teal-700 hover:cursor-pointer"
                        onClick={() => setCart(product)}
                      />
                      }
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>       

        <div className="text-gray-300 mx-auto mt-2 px-6 py-2 max-w-7xl lg:px-4 bg-teal-900 rounded-lg">
          
          <h2 className="text-2xl tracking-tight"><CheckBadgeIcon  className="inline-block h-6 w-6 text-green-500" /> สินค้าแนะนำ</h2> 
          <div className="overflow-y-auto mt-6 grid gap-x-2 gap-y-4 grid-cols-2 sm:grid-cols-4 md:grid-cols-5  xl:gap-x-6 text-gray-600">
            {recommend?.map((product) => (
              product.price>0 &&
              <div key={product.id} className="group relative rounded-md hover:border-orange-500 hover:border-2 hover:rounded-md bg-gradient-to-t from-slate-100 from-10% to-60%">
                <div className="grid content-between w-full h-full">
                  <img
                    alt={product.name}
                    src={`${imgurl}/${product.img}`}
                    className="w-full rounded-md object-cover group-hover:opacity-75 hover:cursor-pointer"
                    onClick={() => handleClickOpen(product)}
                  />
                  <div className="mt-4 p-1 flex justify-between">
                    <div>
                      <h3 className="text-sm">
                          <span aria-hidden="true" className="" />
                          {product.name}
                      </h3>
                      <p className="mt-1 text-sm inline-block">{product.category}</p>
                      
                    </div>
                    <div>
                      <p className="flex items-center justify-end p-1 text-sm font-medium text-gray-300 bg-green-600 rounded-full">{product.price}</p>
                      {enable==='true' && <ShoppingCartIcon 
                        className="h-6 w-6 text-teal-500 inline-block hover:text-teal-700 hover:cursor-pointer"
                        onClick={() => setCart(product)}
                      />
                      }
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>          

      </div>
      {pd && <CardProduct {...{pd, enable, setPd, open, setOpen}} />}

    </div>

  )
}

ProductList.propTypes = {}

export default ProductList